import React from 'react';
import { TableRow, makeStyles } from '@material-ui/core';
import { Field } from 'formik';
import Fields from 'components/Fields';
import TableComponents from 'components/Table';
import Icons from 'components/Icons';

const useStyles = makeStyles({
  cell: {
    padding: '0.3rem',
    border: '0',
    verticalAlign: 'bottom',
    paddingLeft: '0px'
  },
  deleteIcon: {
    fontSize: '1.2rem',
    cursor: 'pointer'
  },
  inputs: {
    '& label': {
      width: 'unset'
    }
  }
});

const Customer = ({
  removeCustomer,
  index,
  onChange,
  disabled
}: {
  removeCustomer: () => void;
  index: number;
  onChange?: Function;
  disabled?: boolean;
}) => {
  const classes = useStyles();
  return (
    <TableRow style={{ width: '100%' }}>
      <TableComponents.TableCell className={classes.cell}>
        <Field
          style={{ width: '150px' }}
          name={`customers[${index}].first_name`}
          component={Fields.v2.Text}
          label="First name"
          onChange={(e: any) => !!onChange && onChange(e, 'first_name')}
          disabled={disabled}
        />
      </TableComponents.TableCell>
      <TableComponents.TableCell className={classes.cell}>
        <Field
          style={{ width: '150px' }}
          name={`customers[${index}].last_name`}
          component={Fields.v2.Text}
          label="Surname"
          onChange={(e: any) => !!onChange && onChange(e, 'last_name')}
          disabled={disabled}
        />
      </TableComponents.TableCell>
      {index !== 0 && (
        <TableComponents.TableCell
          className={classes.cell}
          width="24px"
          onClick={() => removeCustomer()}
        >
          <Icons.DeleteIcon className={classes.deleteIcon} />
        </TableComponents.TableCell>
      )}
    </TableRow>
  );
};

export default Customer;
